import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../components/AuthProvider";
import Header from "../components/Header";
import { API_DOMAIN } from "../utils/constants";
import { useSetRecoilState } from "recoil";
import { userData } from "../recoil/atom/userData";

const Login = () => {
  const setUser = useSetRecoilState(userData);
  const [btnLoading, setBtnLoading] = useState(false);
  const [whatsAppNumber, setWhatsAppNumber] = useState("");
  const [error, setError] = useState("");
  const [showOTP, setShowOTP] = useState(false);
  const [otp, setOTP] = useState("");
  const [showLogin, setShowLogin] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate("/dashboard/sales");
    }
  }, [isAuthenticated, navigate]);

  const handleWhatsAppNumberChange = (e) => setWhatsAppNumber(e.target.value);
  const handleOTPChange = (e) => setOTP(e.target.value);

  const checkWhatsAppNumber = async () => {
    setBtnLoading(true);
    try {
      await axios.get(`${API_DOMAIN}/otp?whatsAppNumber=${whatsAppNumber}`);
      setShowOTP(true);
      setShowLogin(true);
      setError("");
    } catch (error) {
      if (error.status === 404 || error.status === 401) {
        setError(error?.response?.data?.message ?? "Dealer not registered.");
      } else {
        setError("Something went wrong, please try again later");
      }
      setBtnLoading(false);
    }
  };

  const verifyOTP = async () => {
    try {
      const response = await axios.get(
        `${API_DOMAIN}/login?whatsAppNumber=${whatsAppNumber}&otp=${otp}`
      );
      if (response.status === 401) {
        setError("Invalid OTP");
      } else if (response.status === 404) {
        setError("WhatsApp Number does not exist");
      } else if (response.status === 500) {
        setError("Something went wrong, try again later");
      } else {
        window.localStorage.setItem("token", response.data.token);
        window.localStorage.setItem("expiryTime", response.data.expiryTime);
        window.localStorage.setItem("isAuthenticated", "true");
        setUser(response.data.user);
        login(() => {
          navigate("/dashboard/sales");
        });
      }
    } catch (error) {
      if (error.response.status === 401) {
        setError("Invalid OTP");
      } else if (error.response.status === 404) {
        setError("WhatsApp Number does not exist");
      } else {
        setError("Something went wrong, try again later");
      }
    }
  };

  return (
    <>
      <Header />
      <div className="flex flex-col justify-center items-center min-h-[97vh] px-10 pb-20  bg-gradient-to-b from-gray-950 via-black to-gray-900  transition-colors">
        <h1 className="pb-3 text-xl  leading-tight tracking-tight text-white">
          Login to your account
        </h1>
        <div className="w-full max-w-md bg-gray-800 rounded-lg shadow-md p-8">
          <label className="block mb-2 text-sm font-medium text-gray-200">
            WhatsApp Number
          </label>
          <input
            type="text"
            className={`block w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-blue-400 transition
                ${!showOTP && error ? " border-red-400" : " border-gray-700"}
              bg-gray-900  text-gray-100
              `}
            value={whatsAppNumber}
            onChange={handleWhatsAppNumberChange}
            placeholder="Enter WhatsApp Number"
          />
          {!showOTP && error && (
            <p className="mt-1 text-sm text-red-500 dark:text-red-400">
              {error}
            </p>
          )}

          {showOTP && (
            <>
              <label className="block mt-6 mb-2 text-sm font-medium text-gray-200">
                OTP
              </label>
              <input
                type="text"
                className={`block w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 transition
                    ${error ? " border-red-400" : " border-gray-700"}
                  bg-gray-900  text-gray-100
                  `}
                value={otp}
                onChange={handleOTPChange}
                placeholder="Enter OTP"
              />
              {error && (
                <p className="mt-1 text-sm text-red-500 dark:text-red-400">
                  {error}
                </p>
              )}
            </>
          )}
          <div className="text-center">
            {!showLogin && (
              <button
                className="mt-6 items-center py-2 rounded-lg transition bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 px-5 py-2 rounded-lg font-semibold shadow-lg hover:brightness-110 transition-all disabled:opacity-50"
                onClick={checkWhatsAppNumber}
                disabled={btnLoading}
              >
                {btnLoading ? "Sending OTP..." : "Send OTP"}
              </button>
            )}
            {showLogin && (
              <button
                className="mt-6 inline-flex items-center gap-2 bg-gradient-to-r from-teal-400 to-cyan-400 text-gray-900 px-5 py-2 rounded-lg font-semibold shadow-lg hover:brightness-110 transition-all"
                onClick={verifyOTP}
              >
                Login
              </button>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
